module.exports = __webpack_public_path__ + "media/residential.4f814d8f.png";